import { render, staticRenderFns } from "./MediaPackageTable.vue?vue&type=template&id=0f129cf1&"
import script from "./MediaPackageTable.vue?vue&type=script&lang=js&"
export * from "./MediaPackageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports